import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { ABreadCrumb } from '../components/atoms';
import { MLoader } from '../components/molecules';
import { OCategorie } from '../components/organisme';

import { breadcrumbConfig } from '../config/breadcrumb.config';
import { fetchCategories } from '../redux/content/contentActions';
import { changeHead } from '../redux/head/headActions';
import pageConfig from '../config/page.config';

const mapStateToProps = state => ({
	language: state.head.language,
	items: state.content.category,
	isFetching: state.content.isFetching,
});

class ProductCategoryPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [],
			isFetching: true,
			pageType: '',
		};
	}

	componentDidMount() {
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');
		this.props.fetchCategories(crumbs[0]);
		this.props.changeHead({
			id: pageConfig.productCategory.id,
			title: this.props.intl.formatMessage({ id: pageConfig.productCategory.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.productCategory.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	render() {
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');
		const translatedCrumbs = crumbs.map(crumb => breadcrumbConfig[crumb][this.props.language]);
		let content = <MLoader className="article--loader" />;


		if (!this.state.isFetching) {
			content = <OCategorie href={this.props.match.url} items={this.state.items} />;
		}

		return (
			<section className="section--breadcrumb">
				<article className="article--breadcrumb">
					<ABreadCrumb
						currentPage={`${translatedCrumbs.slice(translatedCrumbs.length - 1)}`}
						parents={translatedCrumbs.slice(0, -1)}
						mappedUrl={crumbs.slice(0, -1)}
					/>
				</article>
				<div className="section-xx layout-body--fill">
					{content}
				</div>
			</section>
		);
	}
}

ProductCategoryPage.propTypes = {
	fetchCategories: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};
export default withRouter(connect(mapStateToProps, {
	fetchCategories,
	changeHead,
})(injectIntl(ProductCategoryPage)));



// WEBPACK FOOTER //
// ./src/pages/product-category.page.js